import { useEffect, useState } from 'react';
import { getNiitaConsultations, sendNiitaConsultation } from '../../../../../services/api/1C';
import { toast } from 'react-toastify';

const NiitaConsultation = ({ inspectionKitId }) => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [answerHistories, setAnswerHistories] = useState([]);

  useEffect(() => {
    getNiitaConsultations(inspectionKitId).then((resHistories) => {
      setAnswerHistories(resHistories.data || []);
    });
  }, []);

  const handleSubmit = async () => {
    if (!question.trim()) return;

    setIsLoading(true);

    try {
      const res = await sendNiitaConsultation({
        inspectionKitId,
        question: question.trim(),
      });
      if (!res?.data?.answer) {
        toast.error('回答の取得に失敗しました');
        return;
      }
      setAnswer(res?.data?.answer ?? null);
      setQuestion('');
      const resHistories = await getNiitaConsultations(inspectionKitId);
      setAnswerHistories(resHistories.data);
    } catch (err) {
      console.error('Consultation error:', err);
      toast.error('相談の送信に失敗しました');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section
      className="bg-white mt-4 rounded-xl shadow-md border border-slate-200 overflow-hidden w-full"
      id="consultation"
    >
      <div className="bg-slate-50 px-4 py-3 border-b border-slate-100">
        <h4 className="text-sm font-bold text-slate-700 flex items-center gap-2">
          <span className="material-symbols-outlined text-lg">chat_bubble</span>
          Niitaに相談
        </h4>
      </div>
      <div className="p-5">
        <div className="space-y-3">
          <label className="text-[11px] leading-relaxed text-slate-500 block">
            最近の頭皮の悩みや、気になる生活習慣、今後どうなりたいかなど、自由にご記入ください。
            <br />
            <span className="text-slate-400 font-normal">
              （例：最近抜け毛が気になり始めたので、効果的なマッサージを知りたい）
            </span>
          </label>

          <textarea
            className="w-full bg-slate-50 border border-slate-200 text-slate-700 text-sm rounded-lg p-3 h-32 focus:border-2 focus:border-sky-500 focus:outline-none transition"
            placeholder="ここに入力してください..."
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            disabled={isLoading}
          />

          <button
            onClick={handleSubmit}
            disabled={isLoading || !question.trim()}
            className="w-full bg-sky-500 hover:bg-sky-600 text-white text-sm font-bold py-2.5 rounded-lg shadow-sm transition flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <span className="material-symbols-outlined text-lg animate-spin">progress_activity</span>
                送信中...
              </>
            ) : (
              <>
                <span className="material-symbols-outlined text-lg">send</span>
                相談内容を送信する
              </>
            )}
          </button>
        </div>

        {answerHistories.map((eachAnswerHistory) => (
          <div key={eachAnswerHistory._id} className="mt-4 pt-4 border-t border-slate-100">
            <div className="flex items-center gap-2 mb-2">
              <span className="material-symbols-outlined text-primary text-lg">chat_bubble</span>
              <span className="text-sm font-bold text-slate-700">{eachAnswerHistory.question}</span>
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="material-symbols-outlined text-primary text-lg">smart_toy</span>
              <span className="text-sm font-bold text-slate-700">Niitaからの回答</span>
            </div>
            <div className="bg-sky-50 border border-sky-100 rounded-lg p-4 max-h-[400px] overflow-y-auto">
              <p className="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed">{eachAnswerHistory.aiAnswer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NiitaConsultation;
